import type { JSX } from 'react'

export const InstagramIcon = (): JSX.Element => (
  <use href='#instagramIcon' height='100%' width='100%' />
)
